<!--
 * @Author: your name
 * @Date: 2020-12-13 11:51:19
 * @LastEditTime: 2021-05-21 17:28:14
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/tab-admin/tab-history/components/OrderDetail/index.vue
-->
<style scoped lang="sass">
.app_container
  padding: 10px 16px
  border-bottom: 1px solid rgba(51, 68, 85, .1)

  .order_info
    display: flex
    justify-content: space-between
    font-size: 14px
    color: #334455

    .order_no
      margin-right: 8px
      font-weight: bold

  .product_info
    margin-top: 4px
    font-size: 12px
    color: rgba(51, 68, 85, 0.75)
    .date_info
        margin-bottom: 4px

    .each_product
      display: flex
      font-size: 14px

      .product_no
        margin-right: 8px

.flex_box
  display: flex
</style>

<template lang="pug">
.app_container
  .order_info
    .flex_box
      .order_no {{ order.orderNo | orderNoFilters }}
      .order_name {{ order.name }}
    .order_amount {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ order.totalAmount | moneyFilters }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
  .product_info
    .date_info {{ order.orderTime | dateFormatFilters }}
    .each_product(
      v-for="(item, index) in order.products"
      :key="index"
    )
      .product_no {{ item.no }}
      .product_name {{ productName(item) }}

</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { _DateFilters, _getFormatTime } from 'utils/format'
import { formatDecimalNumber, getCurrencySymbol, getSymbolPosition } from '@/utils/currency'

@Component({
  props: {
    order: Object
  },

  filters: {
    orderNoFilters(val) {
      return val.substring(val.length - 4)
    },

    dateFormatFilters(val) {
      const [date, time] = val.split(' ')
      const formatDate = _DateFilters(date)
      const formatTime = _getFormatTime(time)
      return formatTime + ' - ' + formatDate
    },

    moneyFilters(val) {
      if (val) return formatDecimalNumber(Number(val))
      return val
    }
  },

  computed: {
    currencySymbol() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getCurrencySymbol()
    },
    symbolPosition() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getSymbolPosition()
    }
  }
})

class OrderDetail extends Vue {
  productName(product) {
    let name = product.name
    if (product.selectSizeShortName) name += ` (${product.selectSizeShortName})`
    return name
  }
}

export default OrderDetail
</script>
